import { render, staticRenderFns } from "./agentFenxiaoApprove.vue?vue&type=template&id=3fedf6d9&scoped=true"
import script from "./agentFenxiaoApprove.vue?vue&type=script&lang=js"
export * from "./agentFenxiaoApprove.vue?vue&type=script&lang=js"
import style0 from "./agentFenxiaoApprove.vue?vue&type=style&index=0&id=3fedf6d9&prod&scoped=true&lang=css"
import style1 from "./agentFenxiaoApprove.vue?vue&type=style&index=1&id=3fedf6d9&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fedf6d9",
  null
  
)

export default component.exports